import create from './case'
const home = [
    create("/", "/", "home/home", "首页"),
    create("/promotion/index", "promotion-index", "promotion/index/index", "推广工具",true),
    create("/promotion/create", "promotion-create", "promotion/create/create", "生成推广工具"),
    create("/merits", "merits", "merits/merits", "业绩",true),
    create("/mine", "mine", "mine/mine", "我的",true),
];
export default home;
